<my-search-typeahead class="w-100 d-flex justify-content-end"></my-search-typeahead>

<a class="publish-button" routerLink="/videos/upload">
  <my-global-icon iconName="upload" aria-hidden="true"></my-global-icon>
  <span i18n class="publish-button-label">Publish</span>
</a>
